import React, { Component } from "react";

import {
  CCard,
  CCardBody,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle
} from "@coreui/react";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn
} from "react-bootstrap-table";
import { withRouter } from "react-router-dom";

import data from "./dummy";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";
import "./tables.css";

class TableAccess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // list: this.props.list,
      // path: this.props.path,
      // selectedList: [],
      header: []
      // updateDel: false
    };

    this.table = data.rows;

    this.renderPaginationPanel = props => (
      <div>
        <div>{props.components.pageList}</div>
        <div>
          <span>Change size per page: </span>
          {props.components.sizePerPageDropdown}
        </div>
        <div>
          <button
            onClick={() => props.changeSizePerPage(25)}
            className="btn btn-default"
          >
            Click to force size per page as 25
          </button>
          <button
            onClick={() => props.toggleDropDown()}
            className="btn btn-default"
          >
            Click to force toggle dropdown
          </button>
          <button
            onClick={() => props.changePage(3)}
            className="btn btn-default"
          >
            Jump to page 3
          </button>
        </div>
      </div>
    );

    this.onToggleDropDown = toggleDropDown => {
      toggleDropDown();
    };

    this.renderSizePerPageDropDown = props => (
      <CDropdown className="d-inline-flex">
        <CDropdownToggle color="outline-secondary" className="text-muted">
          {props.currSizePerPage}{" "}
        </CDropdownToggle>
        <CDropdownMenu>
          {props.sizePerPageList.map((n, idx) => {
            const isActive = n.text === props.currSizePerPage ? "active" : null;
            return (
              <CDropdownItem
                key={idx}
                className={isActive}
                onClick={() => props.changeSizePerPage(n.value)}
              >
                {n.text}
              </CDropdownItem>
            );
          })}
        </CDropdownMenu>
      </CDropdown>
    );

    this.createCustomExportCSVButton = onClick => (
      <CDropdownItem onClick={onClick}>Exportar</CDropdownItem>
    );

    this.createCustomSearchField = props => (
      <SearchField
        className="table-search-input"
        style={{ maxWidth: "200px" }}
        defaultValue=""
        placeholder="Procurar"
      />
    );

    this.createCustomToolBar = props => (
      <div
        className="card-header d-flex align-items-center w-100"
        style={{ margin: "0 15px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
          <h4 className="card-title mb-1 align-items-center">
            {this.props.backButton && (
              <i
                className="fa fa-angle-left mr-3 font-weight-bold cursor"
                onClick={() => this.props.history.goBack()}
              ></i>
            )}
            {this.props.title}
          </h4>
        </div>
        {this.props.extraComponent}
        {(props.components.exportCSVBtn || props.components.deleteBtn) && (
          <CDropdown className="btn-group ml-2">
            <CDropdownToggle color="outline-secondary text-muted" />
            <CDropdownMenu>
              {props.components.exportCSVBtn}
              {props.components.deleteBtn}
            </CDropdownMenu>
          </CDropdown>
        )}
      </div>
    );

    this.onRowMouseOver = row => {
      /* const item = document.createElement("div");
      item.style.width = "600px";
      item.id = "rowEdit";
      item.innerHTML = "teste";
      document.querySelectorAll("tr")[row.id].lastChild.appendChild(item); */
    };

    this.onRowMouseOut = row => {
      /* document.querySelector("#rowEdit").outerHTML = ""; */
    };

    this.options = {
      defaultSortName: this.props.noSort ? undefined : "id",
      defaultSortOrder: "asc",
      sortIndicator: true,
      paginationSize: 3,
      paginationPosition: "bottom",
      sizePerPage: this.props.remote ? this.props.perPage : 10,
      onPageChange: this.props.remote ? this.props.onPageChange : undefined,
      onSizePerPageList: this.props.remote
        ? this.props.onSizePerPageList
        : undefined,
      page: this.props.remote ? this.props.currentPage : undefined,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "30", value: 30 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "Todos", value: this.props.list.length }
      ],
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      paginationShowsTotal: this.renderPaginationShowsTotal,
      alwaysShowAllBtns: true,
      withFirstAndLast: false,
      toolBar: this.createCustomToolBar,
      exportCSVBtn: this.createCustomExportCSVButton,
      noDataText: "A tabela está vazia",
      onRowMouseOver: this.onRowMouseOver,
      onRowMouseOut: this.onRowMouseOut
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    if (this.props.action) {
      let { header } = this.props;
      header.push({ name: "action", denomination: "Ações" });
      this.setState({
        header
      });
    } else {
      this.options.onRowClick = this.click;
      this.setState({
        header: this.props.header
      });
    }
  }

  click = row => {
    if (this.props.pushState) {
      this.props.history.replace({
        ...this.props.history.location,
        state: { ...this.props.pushState }
      });
    }

    return this.props.history.push(this.props.path + row.id);
  };

  members = row => this.props.history.push(this.props.membersPath + row.id);

  print = row => {
    this.props.printAction(row);
  };

  getOptions() {
    return {
      defaultSortName: this.props.noSort ? undefined : "id",
      defaultSortOrder: "asc",
      sortIndicator: true,
      paginationSize: 3,
      paginationPosition: "bottom",
      sizePerPage: this.props.remote ? this.props.perPage : 10,
      onPageChange: this.props.remote ? this.props.onPageChange : undefined,
      onSizePerPageList: this.props.remote
        ? this.props.onSizePerPageList
        : undefined,
      page: this.props.remote ? this.props.currentPage : undefined,
      sizePerPageList: [
        { text: "10", value: 10 },
        { text: "30", value: 30 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        {
          text: "Todos",
          value: this.props.remote
            ? this.props.totalItems
            : this.props.list.length
        }
      ],
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      paginationShowsTotal: this.renderPaginationShowsTotal,
      alwaysShowAllBtns: true,
      withFirstAndLast: false,
      toolBar: this.createCustomToolBar,
      exportCSVBtn: this.createCustomExportCSVButton,
      noDataText: "A tabela está vazia",
      onRowMouseOver: this.onRowMouseOver,
      onRowMouseOut: this.onRowMouseOut,
      onRowClick: !this.props.action && this.click
    };
  }

  render() {
    return (
      <div className="animated">
        <CCard>
          <CCardBody className="p-0">
            <BootstrapTable
              data={this.props.list}
              csvFileName={`${this.props.title}.csv`}
              version="4"
              data-pagination-h-align="top"
              striped
              hover
              remote={this.props.remote === true}
              search={!this.props.remote}
              scrollTop="bottom"
              options={this.getOptions()}
              keyField="id"
              exportCSV={!!this.props.csv}
              trClassName={this.props.trClassName}
              noDataIndication="A tabela esta vazia"
            >
              {this.state.header.map((column, idx) => {
                if (column.name === "id") {
                  return (
                    <TableHeaderColumn
                      width={column.width || "200px"}
                      key={idx}
                      dataField={column.name}
                      dataSort={
                        [true, false].includes(column.dataSort)
                          ? column.dataSort
                          : true
                      }
                    >
                      {column.denomination}
                    </TableHeaderColumn>
                  );
                }
                return (
                  <TableHeaderColumn
                    key={idx}
                    dataField={column.name}
                    dataSort={
                      [true, false].includes(column.dataSort)
                        ? column.dataSort
                        : true
                    }
                    sortFunc={column.sortFunc}
                    width={column.width}
                    dataFormat={column.dataFormat}
                  >
                    {column.denomination}
                  </TableHeaderColumn>
                );
              })}
            </BootstrapTable>
          </CCardBody>
        </CCard>
      </div>
    );
  }
}

export default withRouter(TableAccess);
